/**
 * This module contains queries and mutations for greener eyes.
 */
import { gql } from 'graphql-request';

export const GREENER_EYES_KEY = 'GREENER_EYES_KEY';

export const GREENER_EYES_MINIMAL_KEY = 'GREENER_EYES_MINIMAL_KEY';

export const READ_MINIMAL_GREENER_EYES = gql`
  query {
    greenerEyes {
      greenerEyeId
      externalIdentifier
      name
    }
  }
`;

export const READ_GREENER_EYES = gql`
  query {
    greenerEyes {
      greenerEyeId
      externalIdentifier
      name
      description
      owningOrganisationId
      owningOrganisation {
        externalIdentifier
        name
        mainContactId
        countryId
      }
    }
  }
`;

export const GREENER_EYE_KEY = (greenerEyeExtId) => ['greenerEye', 'externalIdentifier', greenerEyeExtId];
export const READ_GREENER_EYE = gql`
  query getGreenerEye($externalIdentifier: String!) {
    greenerEye(externalIdentifier: $externalIdentifier) {
      greenerEyeId
      externalIdentifier
      name
      description
      owningOrganisationId
      owningOrganisation {
        externalIdentifier
        name
        mainContactId
        countryId
      }
    }
  }
`;

export const CREATE_GREENER_EYE = gql`
  mutation createGrenerEye($greenerEye: GreenerEyeInput!) {
    createGreenerEye(greenerEye: $greenerEye) {
      greenerEye {
        greenerEyeId
        externalIdentifier
        name
        description
        owningOrganisationId
        owningOrganisation {
          organisationId
          externalIdentifier
          name
          mainContactId
          countryId
        }
      }
    }
  }
`;

export const UPDATE_GREENER_EYE = gql`
  mutation updateGreenerEye($greenerEye: GreenerEyeInput!, $greenerEyeId: Int!) {
    updateGreenerEye(greenerEye: $greenerEye, greenerEyeId: $greenerEyeId) {
      greenerEye {
        greenerEyeId
        externalIdentifier
        name
        description
        owningOrganisationId
        owningOrganisation {
          organisationId
          externalIdentifier
          name
          mainContactId
          countryId
        }
      }
    }
  }
`;
